import { render } from "./ContactUsComponent.vue?vue&type=template&id=6e19f4a6"
import script from "./ContactUsComponent.vue?vue&type=script&lang=js"
export * from "./ContactUsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/page/ContactUsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e19f4a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e19f4a6', __exports__)) {
    api.reload('6e19f4a6', __exports__)
  }
  
  module.hot.accept("./ContactUsComponent.vue?vue&type=template&id=6e19f4a6", () => {
    api.rerender('6e19f4a6', render)
  })

}


export default __exports__